<template>
  <component :is="layout"></component>
</template>

<script>
import EventBus from "./plugins/event-bus";
import DefaultLayout from "./layouts/DefaultLayout";
import MainLayout from "./layouts/MainLayout";
export default {
  name: "App",

  components: {
    DefaultLayout,
    MainLayout,
  },

  data: () => ({
    //
  }),
  created() {
    EventBus.$on("closeWebView", this.closeWebView);
  },
  beforeDestroy() {
    EventBus.$off("closeWebView");
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || "default") + "-layout";
    },
  },
  methods: {
    closeWebView() {
      if (typeof closeExam !== "undefined") {
        closeExam.postMessage("true");
      } else {
        if (window.opener) {
          window.opener.postMessage("close", "*");
        }
        if (window.parent) {
          window.parent.postMessage("close", "*");
        }
        window.close();
      }
    },
  },
};
</script>

<style lang="scss">
p {
  margin-bottom: 0 !important;
}
</style>
